export const linkKeysType = ["casestudy", "ebook", "replay"];